import {
  forwardRef,
  type ComponentPropsWithoutRef,
  type ReactNode,
} from 'react'

type H1Props = Omit<ComponentPropsWithoutRef<'h1'>, 'children'> & {
  children: ReactNode
}

export const H1 = forwardRef<HTMLHeadingElement, H1Props>(function H1(
  { children, className = '', ...props },
  ref
) {
  return (
    <h1
      ref={ref}
      className={`font-bold mb-4 text-3xl ${className}`}
      {...props}
    >
      {children}
    </h1>
  )
})
